import { Box, Typography } from "@mui/material";

export default function PageHeader({ title, action, sx = {} }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 1,
        mb: 1.5,
        ...sx,
      }}
    >
      {action}
      <Typography variant="h5" component="h1">
        {title}
      </Typography>
    </Box>
  );
}
